module.exports = __webpack_public_path__ + "graphics/button-family.ckh.bae0b975d621c8ff1cc71ab5ad33ae33.svg";